/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, Input } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { SpinnerComponent } from "typedb-cloud-framework";

export type StatusIcon = "error" | "loading" | "loading_paused" | "inactive" | "ok";

@Component({
    selector: "tp-status-indicator",
    templateUrl: "./status-indicator.component.html",
    styleUrls: ["./status-indicator.component.scss"],
    imports: [MatCheckboxModule, SpinnerComponent]
})
export class StatusIndicatorComponent {
    @Input({ required: true }) status!: StatusIcon;
}
